module.exports = __webpack_public_path__ + "static/media/PAGES.2fc8f45c.svg";